"use strict";
/*
 * Created on 03 13 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Abstract representation of release comment. Consider wisely additional association within concrete implementation with respect
 * to type of release. It provides capability of persistent or temporal comment according to business rules.
 *
 * @author JMe
 */


var AbstractReleaseComment =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(AbstractReleaseComment, _DomainObject_1$Domai);

  /**
   * @param id internal id of comment
   * @param releaseId internal id of release
   * @param userId internal id of user profile which created comment
   * @param username name of user which created comment
   * @param text actual text of comment
   * @param persistent flag whether is is permanent or temporal comment
   * @param deleteOn date of comment deletion if not persistent
   */
  function AbstractReleaseComment(id, releaseId, userId, username, text, persistent, deleteOn) {
    var _this;

    _classCallCheck(this, AbstractReleaseComment);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractReleaseComment).call(this));
    _this.id = id;
    _this.releaseId = releaseId;
    _this.userId = userId;
    _this.username = username;
    _this.text = text;
    _this.persistent = persistent;
    _this.deleteOn = deleteOn;
    return _this;
  }

  return AbstractReleaseComment;
}(DomainObject_1.DomainObject);

exports.AbstractReleaseComment = AbstractReleaseComment;